"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@mui/material/styles");
var _styles2 = require("@mui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "onSelect", "value", "disabled", "highlight", "firstDateInLine", "lastDateInLine", "radius"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles2.makeStyles)(function (theme) {
  return {
    itemWrapper: {
      padding: "2px 0"
    },
    highlight: {
      "& > *": {
        position: "relative",
        "&:before": {
          content: '""',
          width: "100%",
          height: "100%",
          position: "absolute",
          backgroundColor: (0, _styles.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
        }
      }
    },
    highlightFirstDate: {
      "& > *:before": {
        borderTopLeftRadius: function borderTopLeftRadius(props) {
          return props.radius;
        },
        borderBottomLeftRadius: function borderBottomLeftRadius(props) {
          return props.radius;
        }
      }
    },
    highlightLastDate: {
      "& > *:before": {
        borderTopRightRadius: function borderTopRightRadius(props) {
          return props.radius;
        },
        borderBottomRightRadius: function borderBottomRightRadius(props) {
          return props.radius;
        }
      }
    }
  };
});
var ItemWrapper = function ItemWrapper(_ref) {
  var children = _ref.children,
    onSelect = _ref.onSelect,
    value = _ref.value,
    disabled = _ref.disabled,
    highlight = _ref.highlight,
    firstDateInLine = _ref.firstDateInLine,
    lastDateInLine = _ref.lastDateInLine,
    radius = _ref.radius,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles({
    radius: radius,
    firstDateInLine: firstDateInLine,
    lastDateInLine: lastDateInLine
  });
  var handleSelection = function handleSelection() {
    if (!disabled) {
      onSelect(value);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    className: (0, _clsx2["default"])(classes.itemWrapper, _defineProperty(_defineProperty(_defineProperty({}, classes.highlight, highlight && !disabled), classes.highlightFirstDate, firstDateInLine), classes.highlightLastDate, lastDateInLine)),
    onClick: handleSelection
  }, props), {}, {
    children: children
  }));
};
var _default = exports["default"] = ItemWrapper;